import { useEffect, useRef } from 'react';

import { useMapViewSelector } from '@src/contexts';

import { useMapStyle } from './useMapStyle';

export function useActiveMapStyle() {
  const initRef = useRef(false);

  const mapInstance = useMapViewSelector(store => store.mapInstance);

  const { currentMapStyle } = useMapStyle();

  useEffect(() => {
    if (!mapInstance) return;

    // Skip initial style update leading to unnecessary map blinks and style update issues
    if (initRef.current) {
      mapInstance.updateMapStyle(currentMapStyle.value);
    }

    initRef.current = true;
  }, [currentMapStyle.value, mapInstance]);

  return currentMapStyle.value;
}
